import { parseCookie } from 'cookie';

export const getCookies = () =>
  typeof document !== 'undefined' ? parseCookie(document.cookie) : {};
